<!-- <template>
  <div>
    <titulo-modulo :titulo="isEdit() ? 'Editar Dependente' : 'Incluir Dependente'" />
    <v-progress-linear
      indeterminate
      v-if="carregando"
      class="mt-2"
    ></v-progress-linear>
    <template v-else>
      <v-btn
        rounded
        class="mt-2"
        color="error"
        max-height="35"
        :to="{ name: 'dependentes' }"
        >Cancelar</v-btn
      >
      <v-stepper v-model="step" class="mt-2">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1">
            Inserir Informações
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 2" step="2">
            Anexar Documentos
          </v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <editar-informacoes />
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-card flat>
              <v-card-text>
                <anexar-documentos :items="getConfigDocs()" />
              </v-card-text>
              <v-card-actions>
                <finalizar-inclusao />
                <v-btn text small rounded @click="setBackStep()"
                  >Anterior</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import AnexarDocumentos from "../../../components/anexar-documentos/AnexarDocumentos.vue";
import TituloModulo from "../../../components/TituloModulo.vue";
import EditarInformacoes from "./InserirInformacoes.vue";
import FinalizarInclusao from "./FinalizarInclusao.vue";
import moment from "moment";
import { dateUnformat } from "@/global";

export default {
  components: {
    AnexarDocumentos,
    TituloModulo,
    EditarInformacoes,
    FinalizarInclusao,
  },
  computed: {
    ...mapState("dependentes", ["step", "dependenteEnviar", "dependentes"]),
    ...mapState("atestado", ["configs"]),
  },
  data: () => ({
    carregando: true,
  }),
  methods: {
    ...mapActions("atestado", ["getConfigs"]),
    ...mapMutations("atestado", ["setDados"]),
    ...mapMutations("dependentes", ["setBackStep", "setStep", "setDependente"]),
    ...mapGetters("dependentes", ["getConfigDocs"]),
    ...mapMutations("anexos", ["setDocs"]),
    ...mapActions("dependentes", ["getDependentes"]),
    isEdit(){
      return this.$route.params.id > 0;
    }
  },  
  async mounted() {
    this.carregando = true;
    this.setDados("");
    this.setStep(1);
    this.setDocs([]);

    if (this.$route.params.id > 0) {
      if (this.dependentes.length == 0) {
        await this.getDependentes("");
      }
      var depSelec = this.dependentes.find(
        (dep) => dep.codigo == this.$route.params.id
      );
      this.setDependente(depSelec);
      this.setDocs(depSelec.anexos);
      this.dependenteEnviar.nome = depSelec.nome;
      this.dependenteEnviar.depImpostoRenda = depSelec.dependenteir;
      this.dependenteEnviar.dtNascimento = moment(
        dateUnformat(depSelec.nascimento)
      ).format("YYYY-MM-DD");
      this.dependenteEnviar.observacao = "";
      this.dependenteEnviar.inativarDepend = depSelec.solicitou_inativacao;
    } else {
      this.setDependente(null);
      this.setDocs([]);
      this.dependenteEnviar.nome = "";
      this.dependenteEnviar.depImpostoRenda = false;
      this.dependenteEnviar.dtNascimento = moment().format("YYYY-MM-DD");
      this.dependenteEnviar.observacao = "";
      this.dependenteEnviar.inativarDepend = false;
    }

    await this.getConfigs();
    this.carregando = false;
  },
};
</script>

<style>
</style> -->

<template>
  <div>
    <titulo-modulo
      :titulo="isEdit() ? 'Editar Dependente' : 'Incluir Dependente'"
    />
    <v-progress-linear
      indeterminate
      v-if="carregando"
      class="mt-2"
    ></v-progress-linear>
    <template v-else>
      <v-btn
        rounded
        class="mt-2"
        color="error"
        max-height="35"
        :to="{ name: 'dependentes' }"
        >Cancelar</v-btn
      >
      <v-stepper v-model="step" class="mt-2">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1">
            Inserir Informações
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 2" step="2">
            Anexar Documentos
          </v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <editar-informacoes />
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-card flat>
              <v-card-text>
                <anexar-documentos :items="getConfigDocs()" />
              </v-card-text>
              <v-card-actions>
                <finalizar-inclusao />
                <v-btn text small rounded @click="setBackStep()"
                  >Anterior</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import AnexarDocumentos from "../../../components/anexar-documentos/AnexarDocumentos.vue";
import TituloModulo from "../../../components/TituloModulo.vue";
import EditarInformacoes from "./InserirInformacoes.vue";
import FinalizarInclusao from "./FinalizarInclusao.vue";
import moment from "moment";
import { dateUnformat } from "@/global";

export default {
  components: {
    AnexarDocumentos,
    TituloModulo,
    EditarInformacoes,
    FinalizarInclusao,
  },
  computed: {
    ...mapState("dependentes", ["step", "dependenteEnviar", "dependentes"]),
    ...mapState("atestado", ["configs"]),
  },
  data: () => ({
    carregando: true,
  }),
  methods: {
    ...mapActions("atestado", ["getConfigs"]),
    ...mapMutations("atestado", ["setDados"]),
    ...mapMutations("dependentes", ["setBackStep", "setStep", "setDependente"]),
    ...mapGetters("dependentes", ["getConfigDocs"]),
    ...mapMutations("anexos", ["setDocs"]),
    ...mapActions("dependentes", ["getDependentes"]),
    isEdit() {
      return this.$route.params.id > 0;
    },
  },
  async mounted() {
    this.carregando = true;
    this.setDados("");
    this.setStep(1);
    this.setDocs([]);

    if (this.$route.params.id > 0) {
      if (this.dependentes.length == 0) {
        await this.getDependentes("");
      }
      var depSelec = this.dependentes.find(
        (dep) => dep.codigo == this.$route.params.id,
      );
      this.setDependente(depSelec);
      this.setDocs(depSelec.anexos);
      this.dependenteEnviar.nome = depSelec.nome;
      this.dependenteEnviar.depImpostoRenda = depSelec.dependenteir;
      this.dependenteEnviar.dtNascimento = moment(
        dateUnformat(depSelec.nascimento),
      ).format("YYYY-MM-DD");
      this.dependenteEnviar.observacao = "";
      this.dependenteEnviar.inativarDepend = depSelec.solicitou_inativacao;
    } else {
      this.setDependente(null);
      this.setDocs([]);
      this.dependenteEnviar.nome = "";
      this.dependenteEnviar.depImpostoRenda = false;
      this.dependenteEnviar.dtNascimento = moment().format("YYYY-MM-DD");
      this.dependenteEnviar.observacao = "";
      this.dependenteEnviar.inativarDepend = false;
    }

    await this.getConfigs();
    this.carregando = false;
  },
};
</script>

<style></style>
